module.exports = __webpack_public_path__ + "static/media/alien-monster.502483da.svg";